var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.files)?_c('v-col',{staticClass:"pa-0"},_vm._l((_vm.files),function(file){return _c('v-row',{key:file.key,staticClass:"mb-2",attrs:{"dense":""}},[_c('transaction-file',{attrs:{"file":file},on:{"downloadCertificate":_vm.handleClickDocument}})],1)}),1):_c('v-col',[_c('span',[_vm._v(_vm._s(_vm.$vuetify.lang.t('$vuetify.withoutFiles')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }